import React, { useState, useRef, useEffect } from 'react';
import './style.scss';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import Button from '../../../components/Button';
import TopTip from '../../../components/TopTip';
import CheckBox from '../../../components/CheckBox';

import ContactEmailInput, { VerifyContactEmailAction } from '../../../module/common/ContactEmailInput';
import SafePhoneVerify from '../../../module/common/SafePhoneVerify';
import GlobalAction from '../../../store/actions/global';
import ContactEmailInputAction from '../../../module/common/ContactEmailInput/action';

import SafePhoneVerifyAction from '../../../module/common/SafePhoneVerify/action';
import SafePhoneGradeConfirm from '../../../components/SafePhoneGradeConfirm';
import VerifyInputAction from '../../../module/common/VerifyCodeInput/action';

import { VERIFY_ERROR_CODE, } from '../../../common/enum';
import { postRepairTask } from '../../../apis/DataReview';
import { checkSafePhoneGrade } from '../../../apis/MethodList';
import { scrollIntoView } from '../../../utils/common';

const protocolErrorText = '请先勾选并同意服务条款';

const SafePhoneRepair: React.FC = () => {
    const dispatch = useDispatch();
    const state = useSelector((state: any) => state);
    const history = useHistory();
    const hasErrorInThisFrame = useRef<boolean>(false);

    const [protocolBeChosen, setProtocolBeChosen] = useState<boolean>(false);
    const [submitCode, setSubmitCode] = useState<number>(200);
    const [sumitError, setSumitError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [fillMoreInfo, setFillMoreInfo] = useState({ phoneRepair: "" });
    const [safePhoneGradeConfirmVisible, setSafePhoneGradeConfirmVisible] = useState<boolean>(false);
    const { contactEmail, isNeedContactEmail, } = useSelector((state: any) => state.ContactEmailInput);
    const { phoneRepair } = useSelector((state: any) => state.SafePhoneVerify);


    useEffect(() => {
        const formTotalError = Object.values(state).filter((item: any) => {
            if (!!item.errorText) {
                return true;
            }
            const curErrorTexts = (item.errorTexts || []).filter(Boolean);
            return curErrorTexts.length > 0
        })
        if (!formTotalError.length) {
            hasErrorInThisFrame.current = false;
        }
    }, [state, submitCode])

    const checkSafePhoneGradeHandle = async () => {
        let defaultSupport = true;
        try {
            const res = await checkSafePhoneGrade();
            // 检查响应是否存在且状态码为 200
            if (!res || res.code !== 200) {
                return defaultSupport;
            }

            if (res.result) {
                defaultSupport = res.result?.support;
                const extInfo = res.result?.extInfo;
                
                if (!defaultSupport && extInfo?.phoneRepair) {
                    setFillMoreInfo({ phoneRepair: extInfo.phoneRepair });
                    setSafePhoneGradeConfirmVisible(true);
                }
            }

            return defaultSupport;
        } catch (error) {
            // 捕获异常并打印错误信息，默认返回 false
            console.error('检查安全手机等级时出错:', error);
            return defaultSupport;
        }
    };

    const handleDataSubmit = async () => {
        (window as any).mailStats.click('safe_phone_repair_submit', {
            platform: process.env.MAIL_APP_PLATFORM,
        })
        dispatch({
            type: GlobalAction.UPDATE_SUBMIT_CLICK_COUNT,
            playload: state.global.submitClickCount + 1
        })
        hasErrorInThisFrame.current = false;
        if (!protocolBeChosen) {
            setSumitError(protocolErrorText);
            return;
        }
        if (loading) {
            return;
        }
        if (!contactEmail && isNeedContactEmail) {
            dispatch({
                type: ContactEmailInputAction.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                payload: '请输入正确的邮箱账号'
            })
            hasErrorInThisFrame.current = true;
        }

        if (!state?.VerifyCode?.verifyCode && ['VerifyBox'].includes(state.global.verifyPhoneMethod)) {
            dispatch({
                type: SafePhoneVerifyAction.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: '请输入验证码'
            })
            hasErrorInThisFrame.current = true;
        }

        if (!!contactEmail && isNeedContactEmail) {
            const { isValid, desc } = await VerifyContactEmailAction(contactEmail);
            if (!isValid) {
                dispatch({
                    type: ContactEmailInputAction.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                    payload: desc,
                });
                hasErrorInThisFrame.current = true;
            }
        }

        // 当前帧没有产生错误，也没有存量的错误时，可提交
        const formTotalError = Object.values(state).filter((item: any) => {
            if (!!item.errorText) {
                return true;
            }
            const curErrorTexts = (item.errorTexts || []).filter(Boolean);
            return curErrorTexts.length > 0
        })
        if (formTotalError.length || hasErrorInThisFrame.current) {
            scrollIntoView(".error-tip");
            return;
        }
        await checkSafePhoneGradeHandle() && dataSubmit();
    }

    const dataSubmit = async () => {
        const curPhone = state?.PhoneInput?.phoneType?.id === '+86' ? state?.PhoneInput?.phoneNumber : `${state.PhoneInput.phoneType?.id}-${state.PhoneInput.phoneNumber}`
        setLoading(true);
        try {
            const params: Record<string, unknown> = {
                PHONE_REPAIR: [state.global.repairAccount],
                REAL_NAME_INFO:  [],
            };
            const submitRes = await postRepairTask({
                phone: curPhone,
                way: 1,
                code: ["VerifyBox"].includes(state.global.verifyPhoneMethod) ? state?.VerifyCode?.verifyCode : '',
                data: params,
                email: contactEmail,
                repairTimes: (window as any).repair_add_time,
            })
            setLoading(false);
            setSumitError('');
            if (submitRes && submitRes.code === 200) {
                // 提交次数增加
                (window as any).repair_add_time += 1;
                const { taskId, inquireKey } = submitRes.result || {};
                (window as any).mailStats.show('safe_phone_repair_submit_success', {
                    platform: process.env.MAIL_APP_PLATFORM,
                })
                // 跳转逻辑
                history.push({
                    pathname: '/result',
                    search: `?inquireKey=${inquireKey}&taskId=${taskId}`
                })
                setSubmitCode(200);
            } else {
                switch (submitRes.code) {
                    // 验证码相关错误
                    case VERIFY_ERROR_CODE: {
                        // 验证码验证
                        if (["VerifyBox"].includes(state.global.verifyPhoneMethod)) {
                            dispatch({
                                type: SafePhoneVerifyAction.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                                playload: submitRes.desc
                            });
                            return;
                        }
                        setSumitError(submitRes.desc);
                    }; break;
                    default: {
                        setSumitError(submitRes.desc || "网络错误，请稍后再提交");
                    }
                }
            }
        } catch (e) {
            console.log(e);
            setSumitError("网络错误，请稍后再提交");
        }
    }

    const handleProtocolChange = (value: boolean) => {
        if (sumitError === protocolErrorText) {
            setSumitError('')
        }
        setProtocolBeChosen(value);
    }
    React.useEffect(() => {
        (window as any).mailStats.pv('safe_phone_repair', {
            platform: process.env.MAIL_APP_PLATFORM,
        })
    }, []);

    return (
        <div className="data-review-container">
            <TopTip>
                <span>您正在对 <span className="top-tips-account">{state?.global?.repairAccount || ''}</span> 进行身份验证，请提供真实完整的资料</span>
            </TopTip>
            <div className="main">
                <h1 className="title">请填写验证资料</h1>
                <SafePhoneVerify phoneNumber={phoneRepair} />
                <ContactEmailInput required={true} placeholder='建议输入另一个网易邮箱接收结果' label='联系邮箱（用于接收审核结果）' />
                <div className="protocol-btn-wrapper">
                    <CheckBox onChange={(value) => handleProtocolChange(value)} value={protocolBeChosen} extraClass="protocol-btn-checkbox" />
                    <span className="protocol-btn-text">我同意
                        <a href="https://pw.mail.163.com/terms.html" target="_blank" rel="noopener noreferrer">网易邮箱账号修复服务条款</a>
                        和
                        <a href="https://mail.163.com/html/agreement/doc.html" target="_blank" rel="noopener noreferrer">隐私政策</a>
                    </span>
                </div>
                <div className="error"> {sumitError ? sumitError : ''} </div>
                <div className="send-phone-btn-wrapper">
                    <Button loading={loading} text="开始验证" color="primary" onClick={() => handleDataSubmit()} />
                </div>
            </div>
            <SafePhoneGradeConfirm 
                visible={safePhoneGradeConfirmVisible}
                safePhone={fillMoreInfo.phoneRepair}
                onVisible={(visible) => setSafePhoneGradeConfirmVisible(visible)}
            />
        </div>
    )
}

export default SafePhoneRepair
